import { withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["aria-checked", "aria-disabled"]
const _hoisted_2 = ["id", "name", "true-value", "false-value", "disabled"]
const _hoisted_3 = ["aria-hidden"]
const _hoisted_4 = { class: "el-switch__action" }
const _hoisted_5 = {
  key: 0,
  class: "el-icon-loading"
}
const _hoisted_6 = ["aria-hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["el-switch", { 'is-disabled': _ctx.switchDisabled, 'is-checked': _ctx.checked }]),
    role: "switch",
    "aria-checked": _ctx.checked,
    "aria-disabled": _ctx.switchDisabled,
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchValue && _ctx.switchValue(...args)), ["prevent"]))
  }, [
    _createElementVNode("input", {
      id: _ctx.id,
      ref: "input",
      class: "el-switch__input",
      type: "checkbox",
      name: _ctx.name,
      "true-value": _ctx.activeValue,
      "false-value": _ctx.inactiveValue,
      disabled: _ctx.switchDisabled,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.switchValue && _ctx.switchValue(...args)), ["enter"]))
    }, null, 40, _hoisted_2),
    (_ctx.inactiveIconClass || _ctx.inactiveText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(['el-switch__label', 'el-switch__label--left', !_ctx.checked ? 'is-active' : ''])
        }, [
          (_ctx.inactiveIconClass)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass([_ctx.inactiveIconClass])
              }, null, 2))
            : _createCommentVNode("", true),
          (!_ctx.inactiveIconClass && _ctx.inactiveText)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                "aria-hidden": _ctx.checked
              }, _toDisplayString(_ctx.inactiveText), 9, _hoisted_3))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      ref: "core",
      class: "el-switch__core",
      style: _normalizeStyle({ 'width': (_ctx.width || 40) + 'px' })
    }, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("i", _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ], 4),
    (_ctx.activeIconClass || _ctx.activeText)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(['el-switch__label', 'el-switch__label--right', _ctx.checked ? 'is-active' : ''])
        }, [
          (_ctx.activeIconClass)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass([_ctx.activeIconClass])
              }, null, 2))
            : _createCommentVNode("", true),
          (!_ctx.activeIconClass && _ctx.activeText)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                "aria-hidden": !_ctx.checked
              }, _toDisplayString(_ctx.activeText), 9, _hoisted_6))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}